module.exports = __webpack_public_path__ + "img/移除网络3.356dd092.svg";